import { Loader2Icon } from "lucide-react";
import type React from "react";

import { cn } from "@krea/shared/utils";

function Spinner({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Loader2Icon>) {
  return (
    <div className="flex items-center justify-center">
      <Loader2Icon
        role="status"
        aria-label="Loading"
        strokeWidth={2.5}
        className={cn("size-14 animate-spin text-primary", className)}
        {...props}
      />
    </div>
  );
}

export { Spinner };
